import { ApiAccountDashboardModelPortfolio } from 'api/rtk-api'
import { Table } from 'components/core-v2'

import { DEFAULT_COLUMN_DEFS, FOF_COLUMN_DEFS, MODEL_COLUMN_DEFS } from './table-options'
import { ModelAndFundOfFundsPortfolioType } from './types'

interface Props {
  portType: ModelAndFundOfFundsPortfolioType
  portfolios: ApiAccountDashboardModelPortfolio[]
}
export const PortfoliosTab = ({ portType, portfolios }: Props) => (
  <Table
    agGridProps={{
      columnDefs: portType === 'ModelPortfolio' ? MODEL_COLUMN_DEFS : FOF_COLUMN_DEFS,
      defaultColDef: DEFAULT_COLUMN_DEFS,
      headerHeight: 60,
      rowData: portfolios,
      rowHeight: 44
    }}
    className="flex-1"
  />
)
